import request from '@/utils/request'

export function getInfo(data) {
  return request({
    url: '/Api/brand.PayAccount/index',
    method: 'post',
    data
  })
}

export function getSelectorData(data) {
  return request({
    url: '/Api/brand.PayAccount/getSelectorData',
    method: 'post',
    data
  })
}

export function applyment(data) {
  return request({
    url: '/Api/brand.PayAccount/applyment',
    method: 'post',
    data
  })
}

export function editApplyment(data) {
  return request({
    url: '/Api/brand.PayAccount/editApplyment',
    method: 'post',
    data
  })
}